<div class="component-wrapper">
  <lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="header-details-wrapper" [class.no-detail]="!shouldShowDetailView">
        @if (shouldShowDetailView) {
          <div class="details-brief">
            <div class="name-description-container">
              @if (department?.name) {
                <div class="detail-container">
                  <h5>Name</h5>
                  <div class="detail-item" [titleIfTruncated]="department?.name" [maxLength]="30">{{
                    department?.name | formatNameLength : 30
                  }}</div>
                </div>
              }
              @if (department?.description) {
                <div class="detail-container">
                  <h5>Description</h5>
                  <div class="detail-item">{{ department?.description }}</div>
                </div>
              }
            </div>
          </div>
        }
        @if (shouldShowDetailView) {
          <div class="context-actions">
            @if (departmentPrivileges?.canEdit) {
              <button
                class="department-detail-button"
                type="button"
                mat-button
                (click)="onDeactivateClick(department)"
                id="department-deactivate"
                >
                <span class="checkbox-with-label">
                  <mat-checkbox
                    class="deactivate-checkbox"
                    [checked]="department?.isActive"
                    [disabled]="true"
                  ></mat-checkbox>
                  Active</span
                  >
                </button>
              }
              @if (canDelete()) {
                <button
                  class="department-detail-button"
                  mat-button
                  type="button"
                  (click)="onDeleteClick()"
                  id="department-delete"
                  >
                  Delete
                </button>
              }
              @if (departmentPrivileges?.canEdit) {
                <button
                  class="department-detail-button"
                  type="button"
                  mat-button
                  (click)="onUntagClick(department)"
                  id="department-untag"
                  >Untag</button
                  >
                }
                @if (departmentPrivileges?.canEdit) {
                  <button
                    class="department-detail-button"
                    type="button"
                    mat-button
                    (click)="onMergeClick(department)"
                    id="department-merge"
                    >Merge</button
                    >
                  }
                  @if (departmentPrivileges?.canEdit) {
                    <button
                      class="department-detail-button"
                      type="button"
                      mat-button
                      (click)="onRenameClick(department)"
                      id="department-rename"
                      >Rename
                    </button>
                  }
                </div>
              }
            </div>
            <div class="detail-content">
              <ndt-two-column-layout>
                <div ndtRightColumn>
                  @if (!shouldShowDetailView) {
                    <div class="align-to-center"> No existing departments. </div>
                  }
                  <div class="mat-tab-indented">
                    @if (shouldShowDetailView) {
                      <div class="fields-container">
                        <h5>Created</h5>
                        <div class="department-detail-item">{{
                          department?.createDate | date : 'MM/dd/yyy hh:mm aa'
                        }}</div>
                        <div class="department-detail-item">{{ department?.createUser?.name }}</div>
                        <h5>Last Modified</h5>
                        <div class="department-detail-item">{{
                          department?.updateDate | date : 'MM/dd/yyy hh:mm aa'
                        }}</div>
                        <div class="department-detail-item">{{ department?.updateUser?.name }}</div>
                      </div>
                    }
                    <th class="table-descriptor">
                      @if (department?.departmentExtensionsConnection?.items?.length) {
                        <span
                          >Extensions in this department</span
                          >
                        }
                      </th>
                      <mat-divider class="department-extensions-divider"></mat-divider>
                      @if (
                        shouldShowDetailView &&
                        department &&
                        !department?.departmentExtensionsConnection?.items?.length
                        ) {
                        <div
                          >
                          No extensions currently associated with this department.
                        </div>
                      }
                      @if (department?.departmentExtensionsConnection?.items?.length > 0) {
                        <lcs-responsive-table
                          class="department-extension-register"
                          [columns]="columns"
                          >
                          <table #table lcs-table [dataSource]="department?.departmentExtensionsConnection?.items">
                            <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
                            <tr lcs-row *lcsResponsiveRowDef></tr>
                            <ng-container lcsColumnDef="number" width="4">
                              <th lcs-header-cell *lcsHeaderCellDef id="extension-number-column-header">Extension:</th>
                              <td
                                lcs-cell
                                *lcsCellDef="let departmentExtension"
                                [routerLink]="getRouterLink(departmentExtension.extension.extensionId)"
                                >
                                <a>
                                  {{ departmentExtension.extension.number }}
                                </a>
                              </td>
                            </ng-container>
                            <ng-container lcsColumnDef="name" width="4">
                              <th lcs-header-cell *lcsHeaderCellDef id="extension-name-column-header">Name:</th>
                              <td
                                lcs-cell
                                *lcsCellDef="let departmentExtension"
                                [routerLink]="getRouterLink(departmentExtension.extension.extensionId)"
                                >
                                <a>
                                  {{ departmentExtension.extension.name }}
                                </a>
                              </td>
                            </ng-container>
                          </table>
                        </lcs-responsive-table>
                      }
                    </div>
                  </div>
                  <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
                </ndt-two-column-layout>
              </div>
            </form>
          </lcs-loading-overlay>
        </div>
